
export class CustomFieldBuilder {
    constructor() {
        this.customField = {};
    }

    setId(id){
        this.customField.id = id;
        return this;
    }

    setSourceId(sourceId){
        this.customField.sourceId = sourceId;
        return this;
    }

    setActive(active) {
        this.customField.active = active;
        return this;
    }

    setName(name) {
        this.customField.name = name;
        return this;
    }

    setValue(value) {
        this.customField.value = value;
        return this;
    }

    setRequired(required) {
        this.customField.required = required;
        return this;
    }

    setCustomFieldOptions(customFieldOptions) {
        this.customField.customFieldOptions = customFieldOptions;
        return this;
    }

    build(){
        return this.customField;
    }
}